"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickBooksButton = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const green_default_png_1 = (0, tslib_1.__importDefault)(require("./images/green-default.png"));
const green_hover_png_1 = (0, tslib_1.__importDefault)(require("./images/green-hover.png"));
const lib_1 = require("../../lib");
const elements_1 = require("../../elements");
const QuickBooksButton = ({ className, onClick, connected, }) => {
    const [hovering, setHovering] = (0, react_1.useState)(false);
    if (connected) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Button, Object.assign({ linkDanger: true, onClick: onClick }, { children: "Disconnect from QuickBooks" }), void 0));
    }
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)('quick-books-connect-btn', className), onMouseEnter: () => setHovering(true), onMouseLeave: () => setHovering(false), onClick: onClick }, { children: (0, jsx_runtime_1.jsx)("img", { className: 'quick-books-connect-btn__img', src: hovering ? green_hover_png_1.default : green_default_png_1.default, alt: "QuickBooks Connect Logo" }, void 0) }), void 0));
};
exports.QuickBooksButton = QuickBooksButton;
//# sourceMappingURL=QuickBooksButton.js.map